export default class PublicQRCodeData {

  building = null;
  facility = null;
  technicalInfo = null;
  state = null;
  facilityDocumentation = [];

  ownerName = "";
  operatorName = "";
  managerName = "";

  countryName = "";
  provinceName = "";

  manufacturerName = "";
  assemblerName = "";

  facilityUserAssignment = [];
  processResult = [];


  constructor() {
  }
}
